import * as React from "react";
import type { SVGProps } from "react";
const SvgIconChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 8 8"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.34.27c-.18.05-.27.24-.19.4.02.04.39.42 1.66 1.69L5.45 4 3.81 5.64C2.54 6.91 2.17 7.3 2.15 7.32c-.07.15 0 .32.14.4l.12.01c.13 0-.05.17 1.82-1.7C5.5 4.75 5.91 4.33 5.94 4.3l.07-.13c.01-.05.02-.07.02-.17s0-.12-.02-.17q-.03-.07-.07-.13c-.03-.04-.44-.46-1.7-1.72C2.73.48 2.55.3 2.51.28c-.05-.01-.14-.02-.18 0"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconChevronRight;
